

















































































































































































































import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import CloseIcon from '@/components/icons/Close.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import {
  CustomSelectModel,
  CustomSelectOption,
  CustomSelectGroup
} from './CustomSelectModel';
import CustomSelectMenu from './CustomSelectMenu.vue';

@Component({
  components: {
    CustomSelectMenu,
    TextInput,
    CloseIcon
  }
})
export default class CustomSelect extends Vue {
  @Prop(CustomSelectModel) value!: CustomSelectModel;
  @Prop({ default: false }) formStyle!: boolean;
  @Prop() displayName!: string;
  @Prop({ default: false }) error!: boolean;
  @Prop() isVisible!: boolean;
  @Prop({ required: false }) selectAllText!: string;
  @Prop({ required: false }) required!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: '' }) customSelectLabel!: string;
  @Prop({ default: false }) biggerList!: boolean;
  @Prop({ default: false }) relativeWidth?: boolean;
  @Prop({ default: false }) applyOnCheck?: boolean;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({ default: false }) isLoading!: boolean;
  @Prop({ default: false }) light!: boolean;
  @Prop({ default: false }) title!: boolean;
  @Prop({ default: false }) noMinWidth!: boolean;
  @Prop({ default: false }) alwaysShowTitle!: boolean;
  @Prop({ default: false }) highlightError!: boolean;
  @Prop({ default: false }) secondary!: boolean;
  @Prop({ default: false }) isSearch!: boolean;
  @Prop({ default: false }) greenHover!: boolean;
  @Prop({ default: false }) secondarylightError!: boolean;
  @Prop({ default: false }) isFilter!: boolean;
  @Prop({ default: 'right' }) direction?: 'left' | 'right';
  @Prop({ default: false }) selectAllDisabled?: boolean;
  @Prop({ default: '250px' }) maxHeight?: string;
  @Prop({ default: false }) mobileModal?: boolean;
  @Prop({ default: false }) showQtdSelected!: boolean;

  @Inject('$validator') public $validator!: Validator;
  model: CustomSelectModel = this.value;
  @Watch('value')
  onValueChanged(newValue: CustomSelectModel, oldValue: CustomSelectModel) {
    const oldModelValue = this.model.value;
    this.model = newValue;
    if (!newValue.value) this.model.value = oldModelValue;

    this.initSelectState();

    this.filteredGroups = this.model.filteredGroups;
  }

  get customSelectMenuLabel() {
    return this.customSelectLabel || this.selectedOptionLabel;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get maxHeightStyle() {
    if (this.isMobileDevice) return {};

    return {
      maxHeight: this.maxHeight
    };
  }

  get directionStyle() {
    if (this.isMobileDevice && this.mobileModal) return {};

    const styleMapper: Record<'left' | 'right', any> = {
      left: {
        left: 0,
        top: 'calc(100% + 12px)'
      },
      right: {
        right: 0,
        top: 'calc(100% + 12px)'
      }
    };

    if (!this.direction || !styleMapper[this.direction]) return {};

    return styleMapper[this.direction];
  }

  filteredGroups: CustomSelectGroup[] = [];

  selectOpened: boolean = false;
  selectedOptions?: CustomSelectOption[];
  selectedOptionLabel: string = '';
  query: string = '';
  alreadySetSelected: boolean = false;

  get selectVisible(): boolean {
    return this.isVisible;
  }

  timeout?: number;

  created() {
    this.initSelectState();
    this.filteredGroups = this.model.filteredGroups;
  }

  get contentUpdated() {
    return `${this.isLoading}|${this.value}`;
  }

  get qtdOptionsSelected() {
    return this.model.filteredGroups.reduce((acc, current) => {
      return (
        current.options.reduce(
          (acc, curr) => (curr.isSelected ? acc + 1 : acc),
          0
        ) + acc
      );
    }, 0);
  }

  @Watch('contentUpdated', { immediate: true, deep: true })
  updateSelectPosition() {
    const updateSelectPosition = () => {
      const selectTitle = this.$refs.selectTitle as HTMLElement;

      const selectInput = this.$refs.selectInput as HTMLElement;
      if (!selectInput) return;

      const selectContent = this.$refs.selectContent as HTMLElement;
      if (!selectContent) return;

      const selectContentRect = selectContent.getBoundingClientRect();
      const selectInputRect = selectInput.getBoundingClientRect();

      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const selectInputBottom = selectInputRect.top + selectInputRect.height;

      if (selectInputBottom + selectContentRect.height > windowHeight) {
        const offset = selectTitle
          ? selectTitle.getBoundingClientRect().height + 8
          : 0;
        const height = this.isLoading ? 80 : selectContentRect.height;

        selectContent.style.top = `${offset - height}px`;
      } else {
        selectContent.style.top = `${selectInputRect.height + 2}px`;
      }

      if (selectContentRect.top < 80) {
        selectContent.style.top = 'auto';
      }
    };

    this.$nextTick().then(() => updateSelectPosition());
  }

  @Watch('selectOpened')
  onChangeSelectOpened() {
    if (!this.mobileModal || !this.isMobileDevice) return;

    if (this.selectOpened) {
      document.body.classList.add('custom-select-is-opened');
    } else {
      document.body.classList.remove('custom-select-is-opened');
    }

    this.disableContainerScrollable();
  }

  disableContainerScrollable() {
    const el = document.querySelector<HTMLElement>('.container-scrollable');
    if (el) {
      el.style.overflowY = this.selectOpened ? 'hidden' : 'auto';
    }
  }

  optionChange() {
    if (this.applyOnCheck) this.applyClicked();
  }

  initSelectState() {
    let selectedLabel: string[] = [];
    this.model.groups.forEach(group => {
      group.options.forEach(option => {
        if (option.isSelected) {
          if (this.isSearch && !this.alreadySetSelected) {
            this.alreadySetSelected = true;
            this.model.value = option.label;
          } else {
            selectedLabel.push(option.label);
          }
        }
      });
    });

    this.selectedOptionLabel = this.model.updateMenuWithSelected
      ? selectedLabel.join(', ').replace(/,([^,]*)$/, ' and' + '$1')
      : '';
  }

  menuChanged(isMenuOpen: boolean) {
    this.selectOpened = isMenuOpen;

    this.$nextTick(() => {
      if (this.selectOpened) {
        const selectContent = this.$refs.selectContent as HTMLElement;
        const selectContentRect = selectContent.getBoundingClientRect();
        const windowWidth = window.innerWidth;

        if (selectContentRect.left + selectContentRect.width > windowWidth) {
          selectContent.style.left = `${windowWidth -
            (selectContentRect.left + selectContentRect.width)}px`;
        }

        if (isMenuOpen && this.model.hasSearch && !this.isSearch) {
          const searchInput = this.$refs.searchInput as HTMLElement;
          if (searchInput) {
            searchInput.focus();
          }
        }
      }
    });

    setTimeout(() => {
      if (this.selectOpened) {
        window.addEventListener('click', this.closeMenu);
      } else {
        window.removeEventListener('click', this.closeMenu);
      }
    }, 200);
  }

  closeMenu() {
    window.removeEventListener('click', this.closeMenu);

    setTimeout(() => {
      this.selectOpened = false;
      this.clearSearch();
    }, 50);
  }

  contentClick(event: Event) {
    event.stopPropagation();
  }

  allOptionsSelected(groupIndex: number): boolean {
    let options: CustomSelectOption[] = this.model.filteredGroups[groupIndex]
      .options;
    const unselectedCount: number = options.filter(
      (option: CustomSelectOption) => !option.isSelected
    ).length;

    return unselectedCount == 0;
  }

  groupClick(event: Event, groupIndex: number) {
    event.stopPropagation();

    if (this.model.isMultiSelect) {
      let allSelected: boolean = this.allOptionsSelected(groupIndex);
      let options: CustomSelectOption[] = this.model.filteredGroups[groupIndex]
        .options;
      options.forEach((option: CustomSelectOption) => {
        option.isSelected = !allSelected;
      });
    }
  }

  isAllSelected(groupIndex: number) {
    if (this.model.isMultiSelect) {
      let allSelected: boolean = this.allOptionsSelected(groupIndex);
      return allSelected;
    }
  }

  SelectSearchFocus() {
    if (this.query.length > 3) {
      this.menuChanged(true);
    }
  }

  SelectSearch(value: string) {
    this.query = value;
    this.model.value = value;
    if (value.length > 3) {
      this.menuChanged(true);
      this.searchChanged(value);
    } else {
      this.menuChanged(false);
    }
  }

  singleChoiceSelected(option: CustomSelectOption) {
    this.selectOpened = false;
    this.model.value = option.label;
    this.selectedOptions = [option];
    this.selectedOptionLabel = this.model.updateMenuWithSelected
      ? option.label
      : '';

    this.$emit('selectChanged', this.selectedOptions);
    this.closeMenu();
  }

  applyClicked() {
    this.selectOpened = false;
    this.selectedOptions = [];
    let selectedLabel: string[] = [];
    this.model.groups.forEach(group => {
      group.options.forEach(option => {
        if (option.isSelected) {
          this.selectedOptions!.push(option);
          selectedLabel.push(option.label);
        }
      });
    });

    this.selectedOptionLabel = this.model.updateMenuWithSelected
      ? selectedLabel.join(', ').replace(/,([^,]*)$/, ' and' + '$1')
      : '';

    this.$emit('selectChanged', this.selectedOptions);
    this.disableContainerScrollable();
    this.closeMenu();
  }

  clearClicked() {
    this.selectedOptions = [];
    this.selectedOptionLabel = '';
    this.model.groups.forEach(group => {
      group.options.forEach(option => {
        option.isSelected = false;
      });
    });
    this.clearSearch();
  }

  clearSearch() {
    this.filteredGroups = this.model.filteredGroups;
  }

  searchChanged(value: string) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = window.setTimeout(() => {
      this.$emit('searchChange', this.query);
    }, 200);
  }

  handleScroll(event: any) {
    const element = event.target;
    if (element) {
      if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
        this.$emit('loadMore');
      }
    }
  }

  beforeDestroy() {
    document.body.classList.remove('custom-select-is-opened');
    this.disableContainerScrollable();
  }
}
